export const GET_USUARIOS = 'GET_USUARIOS';
export const ADD_USUARIO = 'ADD_USUARIO';
export const UPDATE_USUARIO = 'UPDATE_USUARIO';
export const DELETE_USUARIO = 'DELETE_USUARIO';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
